const ENVIRONMENTS = {
  local: {
    name: 'local',
    appBaseUrl: 'http://localhost:3000',
    suiteAuthAppId: '1',
    suiteApiBaseUrl: 'http://localhost:3000/__local/suite',
    formsApiBaseUrl: 'http://localhost:3000/__local/forms',
    surveysApiBaseUrl: 'http://localhost:3000/__local/surveys',
    authAppsApiBaseUrl: 'http://localhost:3000/__local/auth-admin',
    authServiceApiBaseUrl: 'http://localhost:3000/__local/auth'
  },
  production: {
    name: 'production',
    appBaseUrl: 'https://app.instant-suite.com',
    suiteAuthAppId: '1',
    suiteApiBaseUrl: 'https://api.instant-suite.com',
    formsApiBaseUrl: 'https://api.instant-forms.com',
    surveysApiBaseUrl: 'https://api.instant-surveys.com',
    authAppsApiBaseUrl: 'https://api.instant-auth.com',
    authServiceApiBaseUrl: 'https://auth.instant-auth.com'
  },
  staging: {
    name: 'staging',
    appBaseUrl: 'https://staging-app.instant-suite.com',
    suiteAuthAppId: '1',
    suiteApiBaseUrl: 'https://staging-api.instant-suite.com',
    formsApiBaseUrl: 'https://staging-api.instant-forms.com',
    surveysApiBaseUrl: 'https://staging-api.instant-surveys.com',
    authAppsApiBaseUrl: 'https://staging-api.instant-auth.com',
    authServiceApiBaseUrl: 'https://staging-auth.instant-auth.com'
  }
};

export function getAppConfig(
  hostname = globalThis.location?.hostname || '',
  runtimeEnvironment = globalThis.__APP_ENV__ || ''
) {
  const requestedEnvironment = runtimeEnvironment.toLowerCase();
  const normalizedHostname = hostname.toLowerCase();
  const localHostname = normalizedHostname === 'localhost' || normalizedHostname === '127.0.0.1' || normalizedHostname === '::1';
  const environment = requestedEnvironment === 'local' || requestedEnvironment === 'staging' || requestedEnvironment === 'production'
    ? ENVIRONMENTS[requestedEnvironment]
    : localHostname
      ? ENVIRONMENTS.local
      : normalizedHostname === 'staging-app.instant-suite.com'
        ? ENVIRONMENTS.staging
        : ENVIRONMENTS.production;

  return { ...environment };
}

export const AppConfig = Object.freeze(getAppConfig());
